import Vue from 'vue'
import Vuex from 'vuex'

import Logo from '@/assets/logo.png'
import Empty from '@/assets/empty.png'
import { getUserInfo, removeUserInfo, setUserInfo } from '@/utils/localStorage'

Vue.use(Vuex)

export default new Vuex.Store({
  state () {
    return {
      // 全局检查登录状态定时器id
      globalCheckLoginTimerId: null,
      logoUrl: Logo,
      emptyUrl: Empty,
      userInfo: getUserInfo()
    }
  },
  getters: {
    token (state) {
      return state.userInfo.token
    },
    getUserId (state) {
      return state.userInfo.id
    }
  },
  mutations: {
    setUserInfo (state, newUserInfo) {
      state.userInfo = newUserInfo
      setUserInfo(newUserInfo)
    },
    removeUserInfo (state) {
      state.userInfo = []
      removeUserInfo()
    },
    setGlobalCheckLoginTimerId (state, id) {
      state.globalCheckLoginTimerId = id
    }
  },
  actions: {
  },
  modules: {
  }
})
